import { BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE } from "constants/action-types";

export const updateGuestBuyerWhitelistProductValues = (values) => ({
    payload: values,
    type: BRAND_GUEST_BUYER_WHITELIST_PRODUCT_VALUES_UPDATE,
});
